import { Box, Button, useTheme } from "@mui/material";
import { useCardstore } from "../../stores/cardsStore/useCardsStore";
import { addColumn } from "../../stores/cardsStore/CardsStore";
import { useStatusStore } from "../../stores/statusStore/useStatusStore";

const ColumnSelectButtons = () => {
  const { yantrasColumns, cardIds } = useCardstore();
  const { isDisabled } = useStatusStore();
  const theme = useTheme();

  const addSelectedColumn = (index: number) => {
    addColumn(index);
  };

  const isColumnSelected = (index: number) => {
    const columnCards = yantrasColumns[index].cards;
    return columnCards.every(
      (card) => cardIds[card.id] && cardIds[card.id] > 0
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
      }}
    >
      {yantrasColumns.map((column, index) => (
        <Button
          sx={{
            bgcolor: column.borderColor,
            width: theme.spacing(8),
            height: { xs: theme.spacing(5), sm: theme.spacing(6) },
            borderRadius: "0.5rem",
            border: isColumnSelected(index) ? "2px solid white" : "none",
            opacity: isDisabled ? 0.5 : 1,
          }}
          key={index}
          disabled={isDisabled}
          onClick={() => addSelectedColumn(index)}
        />
      ))}
    </Box>
  );
};

export default ColumnSelectButtons;
